import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../../components/commonButton";
import withModal from "../../../components/withModal";
import InputField from "../../../components/form/InputField";

const CategoryModalInner = ({ onClose, isEdit, categoryName: initialName, onSubmit }) => {
    const [name, setName] = useState(initialName || "");

    useEffect(() => {
        setName(initialName || "");
    }, [initialName]);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        onSubmit(name);
    };

    return (
        <Form onSubmit={handleFormSubmit}>
            <Modal.Body>
                <InputField
                    className="mb-3"
                    label={{ name: "Category Name" }}
                    input={{
                        type: "text",
                        placeholder: "Enter category name",
                        value: name,
                        onChange: (e) => setName(e.target.value),
                        autoFocus: true,
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                <CommonButton variant="outline" title="Cancel" onClick={onClose} type="button" />
                <CommonButton variant="primary" type="submit" title={isEdit ? "Update" : "Create"} />
            </Modal.Footer>
        </Form>
    );
};

const CategoryModal = withModal(CategoryModalInner);

export default CategoryModal;